
import { v4 as uuidv4 } from 'uuid';
import { NotificationPriority, NotificationCategory } from '@/types/notifications';

export class NotificationUtils {
  static generateId(): string {
    return uuidv4();
  }

  static saveToStorage(key: string, data: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error(`Error saving to storage: ${key}`, error);
    }
  }

  static loadFromStorage(key: string): any {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Error loading from storage: ${key}`, error);
      return null;
    }
  }
}
